<template>
	<div class="m-grid__item m-grid__item--fluid m-wrapper">
		<router-view />
	</div>
</template>

<script>
	export default {
		// mounted(){
		// 	this.$router.replace({'name': 'SaleReport'});
		// },

		// beforeRouteUpdate(to, from, next){
	 //    	console.log("beforeRouteUpdate", to);
	 //    },
	}
</script>